import { render, staticRenderFns } from "./BasicThemeFuji.vue?vue&type=template&id=00bdf541&scoped=true&"
import script from "./BasicThemeFuji.vue?vue&type=script&lang=js&"
export * from "./BasicThemeFuji.vue?vue&type=script&lang=js&"
import style0 from "./BasicThemeFuji.vue?vue&type=style&index=0&id=00bdf541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdf541",
  null
  
)

export default component.exports